import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React from 'react';
import { R300 } from '@atlaskit/theme/colors';
import WarningIcon from '@atlaskit/icon/utility/migration/warning';
import { Frame } from '../Frame';
import { IconAndTitleLayout } from '../IconAndTitleLayout';
import { AKIconWrapper } from '../Icon';
import { NoLinkAppearance } from '../styled';
export var MediaInlineCardErroredView = /*#__PURE__*/function (_React$Component) {
  function MediaInlineCardErroredView() {
    var _this;
    _classCallCheck(this, MediaInlineCardErroredView);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, MediaInlineCardErroredView, [].concat(args));
    _defineProperty(_this, "renderMessage", function () {
      var message = _this.props.message;
      var errorMessage = /*#__PURE__*/React.createElement(NoLinkAppearance, null, message);
      return /*#__PURE__*/React.createElement(React.Fragment, null, errorMessage);
    });
    return _this;
  }
  _inherits(MediaInlineCardErroredView, _React$Component);
  return _createClass(MediaInlineCardErroredView, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        onClick = _this$props.onClick,
        isSelected = _this$props.isSelected,
        innerRef = _this$props.innerRef,
        _this$props$testId = _this$props.testId,
        testId = _this$props$testId === void 0 ? 'media-inline-card-errored-view' : _this$props$testId,
        icon = _this$props.icon;
      return /*#__PURE__*/React.createElement(Frame, {
        testId: testId,
        innerRef: innerRef,
        onClick: onClick,
        isSelected: isSelected
      }, /*#__PURE__*/React.createElement(IconAndTitleLayout, {
        icon: icon || /*#__PURE__*/React.createElement(AKIconWrapper, null, /*#__PURE__*/React.createElement(WarningIcon, {
          label: "error",
          LEGACY_size: "small",
          color: "var(--ds-icon-danger, ".concat(R300, ")")
        })),
        title: this.renderMessage()
      }));
    }
  }]);
}(React.Component);